import { render, staticRenderFns } from "./wine-bottle-small.vue?vue&type=template&id=351fcf11"
import script from "./wine-bottle-small.vue?vue&type=script&lang=js"
export * from "./wine-bottle-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports